import type {
  ReactElement,
  ReactNode,
} from 'react';

import styled from 'styled-components';

const StyledErrorPage = styled.div({
  padding: 96,
  textAlign: 'center',
});

export const StyledStatus = styled.div(({
  theme: {
    colors,
    fonts,
    indents,
  },
}) => ({
  ...fonts.H1,
  color: colors.NEUTRAL_DEFAULT,
  marginBottom: indents.INDENT_4,
}));

export const StyledTitle = styled.div(({
  theme: {
    colors,
    fonts,
    indents,
  },
}) => ({
  ...fonts.H4,
  color: colors.NEUTRAL_DEFAULT,
  marginBottom: indents.INDENT_1,
}));

export const StyledDescription = styled.div(({
  theme: {
    colors,
    fonts,
  },
}) => ({
  ...fonts.DEFAULT,
  color: colors.NEUTRAL_DEFAULT,
}));

type Preset = {
  title: ReactNode;
  description?: ReactNode;
};

type Presets = Record<number, Preset>;

const presets: Presets = {
  404: {
    title: 'Страница не найдена',
    description: 'Возможно, страница была удалена или в адресе страницы опечатка.',
  },

  403: {
    title: 'Доступ запрещен',
    description: 'Недостаточно прав для просмотра. Попробуйте авторизоваться заново.',
  },

  500: {
    title: 'Произошла ошибка на сервере',
    description: null,
  },

  503: {
    title: 'Сервис временно не доступен',
    description: 'Проверьте подключение к интернету или повторите попытку позже.',
  },
};

export type ErrorPageProps = {
  /**
   * http-статус
   */
  status: number;
  /**
   * Заголовок страницы
   */
  title?: ReactNode;
  /**
   * Описание/руководство к действиям
   */
  description?: ReactNode;
};

export function ErrorPage({
  status,
  title: titleProp = undefined,
  description: descriptionProp = undefined,
}: ErrorPageProps): ReactElement {
  let title: ReactNode;
  let description: ReactNode;

  if (
    titleProp === undefined
    && descriptionProp === undefined
    && presets[status]
  ) {
    ({ title, description } = presets[status]);
  } else {
    title = titleProp;
    description = descriptionProp;
  }

  return (
    <StyledErrorPage>
      <StyledStatus>
        {status}
      </StyledStatus>

      {
        title && (
          <StyledTitle>
            {title}
          </StyledTitle>
        )
      }

      {
        description && (
          <StyledDescription>
            {description}
          </StyledDescription>
        )
      }
    </StyledErrorPage>
  );
}
